import Page from 'flarum/common/components/Page';

export default class GuidelinesPage extends Page {
    oninit(){
        this.content = (
            <>
                {m.trust(app.forum.attribute('info-pages.guidelines-content'))}
            </>
        )
    }


    view() {
        return this.content;
    }
}
